import { render, staticRenderFns } from "./FreightDetails.vue?vue&type=template&id=306430bf&scoped=true&"
import script from "./FreightDetails.vue?vue&type=script&lang=js&"
export * from "./FreightDetails.vue?vue&type=script&lang=js&"
import style0 from "./FreightDetails.vue?vue&type=style&index=0&id=306430bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306430bf",
  null
  
)

export default component.exports